import { useCallback, useState } from 'react';
import getWdCar from '../../api/cars/getWdCar';
import Select from '../Select/Select';

const SelectWd = ({ handleSetSelect, handleSetState, style, ...props }) => {
  const [data, setData] = useState([]);
  const onFocus = useCallback(() => {
    getWdCar().then((res) => {
      const wd = res.data.map((item) => {
        return { value: item.id, label: item.title };
      });
      setData(wd);
    });
  }, []);

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={data}
      title={'Тип привода'}
      placeholder={'Выберите из списка'}
      onFocus={onFocus}
      style={style}
      {...props}
    />
  );
};

export default SelectWd;
